import { createSlice } from "@reduxjs/toolkit"

export const initialState = {
  registrationError: null,
  message: null,
  loading: false,
  user: null,
  success: false,
  error: false,
  isUserLogout: true,
  registrationCodeLoading: false,
  registrationCodeSuccess: null,
  registrationCodeError: null,
}

const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    registerUserSuccessful(state: any, action: any) {
      state.user = action.payload.vendor || action.payload.data?.vendor || action.payload.user
      state.loading = false
      state.success = true
      state.registrationError = null
      state.error = false
    },
    registerUserFailed(state: any, action: any) {
      state.user = null
      state.loading = false
      state.registrationError = action.payload
      state.error = true
      state.success = false
    },
    resetRegisterFlagChange(state: any) {
      state.success = false
      state.error = false
      state.registrationError = null
    },
    apiErrorChange(state: any, action: any) {
      state.error = action.payload
      state.loading = false
      state.isUserLogout = false
    },
    // Registration Code actions
    registrationCodeRequest(state: any) {
      state.registrationCodeLoading = true
      state.registrationCodeError = null
      state.registrationCodeSuccess = null
    },
    registrationCodeSuccess(state: any, action: any) {
      state.registrationCodeLoading = false
      state.registrationCodeSuccess = action.payload
      state.registrationCodeError = null
    },
    registrationCodeError(state: any, action: any) {
      state.registrationCodeLoading = false
      state.registrationCodeError = action.payload
      state.registrationCodeSuccess = null
    },
    resetRegistrationCodeFlag(state: any) {
      state.registrationCodeLoading = false
      state.registrationCodeSuccess = null
      state.registrationCodeError = null
    },
  },
})

export const {
  registerUserSuccessful,
  registerUserFailed,
  resetRegisterFlagChange,
  apiErrorChange,
  registrationCodeRequest,
  registrationCodeSuccess,
  registrationCodeError,
  resetRegistrationCodeFlag,
} = registerSlice.actions

export default registerSlice.reducer
